/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z",
  fill: "url(#hrxkitp__a)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.527 11.894c2.915-1.27 4.859-2.107 5.831-2.512 2.777-1.155 3.354-1.355 3.73-1.362.083-.001.268.02.388.116a.421.421 0 0 1 .142.271c.014.078.03.255.017.394-.15 1.581-.802 5.418-1.133 7.19-.14.749-.416 1-.683 1.024-.581.054-1.022-.383-1.584-.752-.88-.577-1.378-.936-2.232-1.499-.987-.65-.347-1.008.215-1.593.148-.153 2.706-2.48 2.756-2.691.006-.026.012-.125-.047-.177-.058-.052-.144-.034-.207-.02-.088.02-1.494.95-4.218 2.788-.399.274-.76.408-1.084.4-.357-.007-1.044-.201-1.555-.367-.626-.204-1.124-.311-1.08-.657.022-.18.27-.364.744-.553Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hrxkitp__a",
  x1: 12,
  y1: 2,
  x2: 12,
  y2: 21.852,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2AABEE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#229ED9"
})))), "0 0 24 24", "ColoredTelegram");